import { MessageActions } from './actions';
import { ReduxAction } from '../core';
import { ToastParams } from './types';
import { takeLatest } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

function* handleSetMessage(action: ReduxAction<ToastParams>) {
  yield toastr[action.data.type](action.data.title || '', action.data.content || '');
}

export function* toastMessageFlow() {
  yield takeLatest(MessageActions.TOAST_MESSAGE, handleSetMessage);
}
